<div class="text-input-widget">
	<div class="infopanel">
		<span *ngIf="currentChar == 'delete'" class="white delete-icon">{{tr('EDITOR_ZONE_NAME_DELETE')}}</span>
		<span *ngIf="currentChar == 'space'" class="white space-icon">{{tr('EDITOR_ZONE_NAME_SPACE')}}</span>
		<span *ngIf="currentChar == 'save'" class="white save-icon">{{tr('EDITOR_ZONE_NAME_SAVE')}}</span>
	</div>
	<div>
		<span class="specialchar icon inline-icon delete-icon" [ngClass]="{'iconBackAndDelete':currentChar == 'delete','iconBackAndDeleteGrey':currentChar != 'delete'}"></span>
		<span class="specialchar icon inline-icon space-icon"  [ngClass]="{'iconBlank':currentChar == 'space','iconBlankGrey':currentChar != 'space'}"></span>
		<span class="alphabet">
			<div class="slide" [ngStyle]="{'left':alphabetOffset}">
				<span *ngFor="let char of characters" class="char" [ngClass]="{'selected':currentChar == char}">{{char}}</span>
			</div>
		</span>
		<span class="specialchar icon inline-icon save-icon" [ngClass]="{'iconSubmit':currentChar == 'save','iconSubmitGrey':currentChar != 'save'}">&gt;</span>
	</div>
</div>